import React, { useCallback, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/graph'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'

const CartesianEChart = ({
    id,
    height,
    options,
    onClick,
}) => {
    const chartContainer = useRef(null)
    const chart = useRef(null)

    const setOption = () => {
        if (!chart.current) {
            return
        }

        const option = {
            tooltip: {
                trigger: 'item',
            },

            animation: false,

            grid: {
                left: 80,
                right: 80,
                top: 40,
                bottom: 40,
                containLabel: true,
            },

            xAxis: {
                type: 'value',
                show: false,
            },

            yAxis: {
                type: 'value',
                show: false,
                inverse: true,
            },

            ...options,
        }

        chart.current.setOption(
            option,
            true,
        )

        chart.current.off('click')

        chart.current.on(
            'click',
            params => {
                if (onClick) {
                    onClick(params)
                }
            },
        )
    }


    const resizeChart = useCallback(() => {
        if (
            chart.current &&
        !chart.current.isDisposed()
        ) {
            chart.current.resize()
        }
    }, [])


    useEffect(() => {
        if (!chartContainer.current) return () => {}

        chart.current = echarts.init(chartContainer.current)

        setOption()
        window.addEventListener('resize', resizeChart)

        return () => {
            window.removeEventListener('resize', resizeChart)
            if (chart.current &&!chart.current.isDisposed()) {
                chart.current.dispose()
            }
        }
    }, [resizeChart])

    useEffect(() => {
        setOption()
    }, [options])

    return (
        <div
            id={id}
            ref={chartContainer}
            style={{
                width: '100%',
                height,
            }}
        />
    )
}


CartesianEChart.propTypes = {
    id: PropTypes.string,
    height: PropTypes.number,
    options: PropTypes.object,
    onClick: PropTypes.func,
}

CartesianEChart.defaultProps = {
    id: 'cartesianGraph',
    height: 500,
    options: {},
    onClick: null,
}

export default CartesianEChart